import { Injectable } from "@angular/core";
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from "@angular/common/http";
import { Observable } from "rxjs";
import { OpenIdConnectService } from "../services/oidc/open-id-connect.service";
import * as _config from '../services/config';

@Injectable()
export class AddAuthorizationHeaderInterceptor implements HttpInterceptor {
    constructor(private oidcService: OpenIdConnectService) {

    }

    intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
        // add the access token as bearer token
        if (request.url.startsWith(_config.serviceName)) {
            //console.log('request', request);
            request = request.clone({
                setHeaders: { Authorization: "Bearer " + this.oidcService.user.id_token }
            });
        }

        return next.handle(request);
    }
}
